import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import classNames from 'classnames';

import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { getWebviewOs } from '@client/redux/modules/clientDevice/selectors';
import { getHasAccessibleOrange } from '@client/redux/modules/abtesting/accessibleOrange/selectors';
import Header from '@client/components/header';
import Footer from '@client/components/footer';
import Usabilla from '@client/components/usabilla';
import SuccessMessageOverlay from '@client/components/successMessageOverlay';
import PreliminaryOrderOverlay from '@client/components/shared/preliminaryOrderOverlay/PreliminaryOrderOverlay';

import { isTouchScreen } from '../../helpers';
import BranchIo from '../../components/shared/BranchIo';


import '../../styles/core.scss';

/* eslint-disable react/prefer-stateless-function */

const mapStateToPros = state => ({
    isWebview: !!getWebviewOs(state),
    accessibleOrange: getHasAccessibleOrange(state),
});

@injectIntl
@connect(mapStateToPros)
export default class CoreLayout extends React.Component {

    render() {
        const {
            intl,
            isWebview,
            accessibleOrange
        } = this.props;

        return (
            <div
                id="inner-wrapper"
                className={classNames(
                    `${!accessibleOrange ? 'brand-color' : ''}`,
                    `${this.getPageClassName()}-page`,
                    {
                        'touch-device': isTouchScreen(),
                        'not-touch-device': !isTouchScreen(),
                        'safe-area-wrapper': isWebview
                    }
                )}
            >
                <Helmet
                    title={intl.formatMessage({ id: 'meta.title' })}
                    meta={[
                        { name: 'description', content: intl.formatMessage({ id: 'meta.description' }) },
                        { name: 'keywords', content: intl.formatMessage({ id: 'meta.keywords' }) }
                    ]}
                />
                <Header location={this.props.location} />
                {this.props.children}
                <Usabilla />
                <Footer />
                <BranchIo />
                <SuccessMessageOverlay />
                <PreliminaryOrderOverlay />
            </div>
        );
    }

    // This function returns the first string between the first two '/' of the router pathname
    // example /campaigns/ZZLE6D -> campaigns
    // then we add a class to the inner-wrapper campaigns-page
    getPageClassName() {
        return this.props.location.pathname.split('/')[1];
    }
}

CoreLayout.propTypes = {
    children: PropTypes.element,
    location: PropTypes.object,
    intl: PropTypes.object,
    isWebview: PropTypes.bool,
    accessibleOrange: PropTypes.bool
};
